import script from "./ProfileConfigView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileConfigView.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileConfigView.vue?vue&type=style&index=0&id=5b1073e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1073e9"]])

export default __exports__